import _ from "lodash";
import {setFieldListOptions} from "../../../apps/KpModule/actions"
import {basicContext} from "../../utils/contextUtils";

export const entity = {
    name: "Control",
    fields: [
        {path: "code", unique: true},
        {path: "name"},
        {
            path: "translatedName",
            fieldPath: ["name"],
            $f: function (object, context, callback) {

                const translate = context?.translateName || (w => w)

                return callback(null, object.name && translate(object.name))
            }
        },
        {path: "controlType", type: "ControlType", fieldPath: ["id", "maturityControls.id"]},
        {path: "maturityControl", type: "MaturityControl"},
        {path: "risk", type: "Risk"},
        {path: "vigilancePoint"},
        {
            path: "fullName",
            fieldPath: ['controlType.translatedName', 'translatedName'],
            f: function () {
                return `${this.controlType?.translatedName} - ${this.name}`
            }
        }
    ],
    filters: [
        {
            name: "byControlType",
            path: "controlType",
            object: "ControlType",
            display: "name",
            translateName: true,
            clearable: true,
            client: true,
            isDefault: false,
            query: function (context) {
                const controlTypeId = _.get(context.data, "controlType.id")
                return controlTypeId ? {controlType: new global.ObjectID(controlTypeId)} : {}
            }
        },
        {
            name: "byAuditScope",
            isDefault: false,
            async: true,
            query: async (context, callback) => {
                const axisIds = (_.get(context, "data.auditScopeIds") || []).map(id => new global.ObjectID(id))
                if (!axisIds.length) return {_id: null}

                const controlTypes = await global.app.AU.ControlType.find({
                    fieldPath: ['id'],
                    ...basicContext(context),
                    query: {
                        axes: { $in: axisIds }
                    }
                })

                const controlTypeIds = controlTypes.map(ct => new global.ObjectID(ct.id))
                return callback(null, {controlType: {$in: controlTypeIds}})
            }
        }
    ]
}

export const module_ = {
    object: "Control",
    tKey: "mTitle_control",
    category: {
        path: "referential",
        icon: 'server'
    },
    defaultSortBy: "code",
    defaultSortDirection: "ASC",
    viewMap: {
        dt: [
            {path: "controlType", display: "codeName"},
            {path: "maturityControl", display: "name", translateName: true, initiallyNotVisible: true},
            "code",
            {path: "name", translateName: true},
            {path: "risk", display: "fullName"},
        ],
        form: [
            {
                path: "controlType",
                display: "codeName",
                fieldPath: ["id", "codeName", "maturityControls.id"],
                subscriptions: {
                    onChange: (newValue, oldValue, {store}) => {
                        const ids = newValue?.maturityControls?.map(mc => mc.id) || []
                        store.dispatch(setFieldListOptions("e_maturityControl", ids))
                    }
                }
            },
            {path: "maturityControl", display: "name", translateName: true, widthClassName: "col-xs-12 col-sm-6"},
            {path: "code", widthClassName: "col-xs-12 col-sm-6"},
            {path: "name", type: "textarea"},
            {path: "risk", display: "fullName"},
            {path: "vigilancePoint", type: "richTextEditor"}
        ]
    },
    filters: ["byControlType"]
}
